import http from "../httpService"
import dayjs from "dayjs"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError } from "@lib/helper"
import fileService from "./fileService"

export enum ImportJobLogStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export interface ImportJobLogItem {
  id: number
  jobType: string
  module: number
  status: ImportJobLogStatus
  totalRecords: number
  successCount: number
  failedCount: number
  creationTime: string
  completedAt: string | null
  hasInputFile: boolean
  hasOutputFile: boolean
}

/** Khuôn `DocumentDto` mà `GetInputFile`/`GetOutputFile` trả về (KHÔNG phải bytes tệp). */
export interface ImportJobLogFileDto {
  fileName: string
  fileType: string
  fileToken: string
}

export interface GetImportJobLogParams {
  module?: number
  jobType?: string
  status?: ImportJobLogStatus
  fromDate?: string
  toDate?: string
  skipCount?: number
  maxResultCount?: number
}

class ImportJobLogService {
  async getAll(params: GetImportJobLogParams): Promise<{ items: ImportJobLogItem[]; totalCount: number }> {
    const res = await http.get("api/services/app/ImportJobLog/GetAll", { params })
    return res.data.result
  }

  /**
   * Tải tệp kết quả (dòng lỗi) của một lần chạy import.
   *
   * PHẢI đi 2 BƯỚC — xem BUG-0386: `GetOutputFileAsync` chỉ trả `fileToken`, bytes nằm trong cache
   * tệp tạm. Gọi kèm `responseType: "blob"` rồi tải thẳng `res.data` sẽ tạo tệp `.xlsx` mà ruột là
   * JSON (Excel báo sai định dạng, console không có lỗi nào).
   *
   * Truyền `importJobLogId` để `FileController.DownloadTempFile` đọc lại tệp từ đĩa khi token đã
   * hết hạn.
   */
  async downloadOutputFile(jobLogId: number): Promise<void> {
    const res = await http.get("api/services/app/ImportJobLog/GetOutputFile", {
      params: { Id: jobLogId },
      // KHÔNG đặt responseType: "blob" — đây là dynamic API, response là JSON envelope.
    })

    const doc = res.data?.result as ImportJobLogFileDto | undefined
    if (!doc?.fileToken) {
      notifyError(LNotification("ERROR"), L("FILE_NOT_FOUND"))
      return
    }

    await fileService.downloadTempFile({
      fileName:
        doc.fileName ||
        `IMPORT-ERROR-${jobLogId}-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`,
      fileType: doc.fileType,
      fileToken: doc.fileToken,
      importJobLogId: jobLogId,
    })
  }
}

export default new ImportJobLogService()
